<div class="ps-14 pe-8 pb-10 pt-6">
  <!-- Card Header Start-->
  <div class="flex justify-between items-center mb-5">
    <div class="flex justify-center">
      <div class="cursor-pointer flex items-center justify-start">
        <div
          class="max-h-12 min-w-12 w-12 h-12 rounded-full overflow-hidden flex items-center justify-center"
        ></div>
      </div>
    </div>
    <button
      class="bg-ThemeWhisper h-7 w-7 rounded-full flex justify-center items-center outline-0 relative group"
      (click)="close()"
    >
      <img
        src="../../../../../../../../assets/theme/images/icons/popup-cross.svg"
        alt="popup cross"
      />

      <!-- Tooltip Container -->
      <div
        class="absolute top-1/2 right-full transform -translate-y-1/2 me-2 flex flex-col items-center hidden group-hover:flex"
      >
        <!-- Tooltip Content -->
        <span
          class="relative rounded-md z-10 px-3 py-1 font-medium text-[12px] leading-5 text-[#DBE0E7] whitespace-no-wrap bg-[#1D232A] shadow-lg"
        >
          <span>Close</span>
          <span class="text-[#2F3A46] ms-2.5">Esc</span>
        </span>
        <!-- Tooltip Arrow -->
        <div
          class="w-2 h-2 rotate-45 bg-[#1D232A] absolute top-1/2 right-[-4px] transform -translate-y-1/2"
        ></div>
      </div>
    </button>
  </div>
  <!-- Card Header End-->

  <!-- Card Body Start-->
  <!--  max-h-[calc(100vh-50px)] overflow-y-auto-->
  <div class="overflow-y-hidden">
    <div
      class="flex w-full max-h-[calc(100vh-230px)] overflow-y-auto pb-12"
    >
      <div class="w-full me-9">
        <div
          class="bg-[#FAFAFA] rounded-[18px] p-9 px-24 flex justify-center items-center"
        >
          <!-- Image -->
          <img
            [src]="filepath"
            alt="Image Preview"
            class="max-h-[calc(100vh-230px)] max-w-full object-cover rounded-[18px] shadow-md"
          />
        </div>
      </div>
    </div>
  </div>
</div>
